require('./transfersAgenda.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @ helpers
const { formatText } = require('core/i18n').i18n;
// @ components
const TransfersAgendaEmptyState = require('components/transfers/transfersAgenda/transfersAgendaEmptyState/transfersAgendaEmptyState');
const TransfersAgendaTableHeader = require('components/transfers/transfersAgenda/transfersAgendaTableHeader/transfersAgendaTableHeader');
const TransfersAgendaTableRow = require('components/transfers/transfersAgenda/transfersAgendaTableRow/transfersAgendaTableRow');
const { LoadingSection } = require('commonsComponents/loadingSection');

class TransfersAgenda extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expandedRow: null
        }

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.buildTableBody = this.buildTableBody.bind(this);
    }

    buildErrorState() {
        const errorMessage = formatText('transfersAgenda-errorFetchingBeneficiaries');
        return (
            <EmptyState primaryText={errorMessage} iconType="nointernet-banking"/>
        );
    }

    buildLoadingState() {
        return (
            <LoadingSection />
        );
    }

    buildTableHead() {
        const { immScreen } = this.props;

        let tableHeadContent;

        if (immScreen.get('isMobile')) {
            tableHeadContent = (
                <thead>
                    <OKTableRow asHeader={true} className="transfers-agenda__table-header-row-line">
                        <OKTableCell
                            asHeader={true}
                            className="transfers-agenda__table-header-cell-line"
                            colSpan={3}
                        />
                    </OKTableRow>
                </thead>
            );
        } else {
            tableHeadContent = (
                <thead>
                    <TransfersAgendaTableHeader />
                </thead>
            );
        }

        return tableHeadContent;
    }

    buildTableBody() {
        const {
            immBeneficiaries,
            immScreen,
        } = this.props;

        return immBeneficiaries.get('byOrder').map((beneficiaryId, index) => {
            const immBeneficiary = immBeneficiaries.getIn(['byId', beneficiaryId]);
            const isExpanded = this.state.expandedRow === index;

            const handleRowClick = () => {
                this.setState({
                    expandedRow: this.state.expandedRow === index ? null : index
                });
            };

            return (
                <TransfersAgendaTableRow
                    key={index}
                    isExpanded={isExpanded}
                    onRowClick={handleRowClick}
                    immBeneficiary={immBeneficiary}
                    immScreen={immScreen}
                />
            );
        });
    }

    render() {
        const { immBeneficiaries } = this.props;
        const tableBodyBlock = this.buildTableBody();
        const headerTitle = formatText('transfersAgenda-tableHeader');
        const addBeneficiaryLabel = formatText('transfersAgenda-newBeneficiaryLabel');
        const tableHead = this.buildTableHead();

        let addBeneficiaryButton = (
            <OKButton
                leftIcon="icon-agregar transfers-agenda__new-beneficiary-icon"
                modifier="ghost"
                to="/myprofile/transfers/agenda/addBeneficiary"
            >
                {addBeneficiaryLabel}
            </OKButton>
        );

        let content;

        if (immBeneficiaries.get('error')) {
            addBeneficiaryButton = null;
            content = this.buildErrorState();
        } else if (immBeneficiaries.get('isFetching')) {
            content = this.buildLoadingState();
        } else if (!immBeneficiaries.get('byOrder').size) {
            content = <TransfersAgendaEmptyState />;
        } else {
            content = (
                <article>
                    <OKTable>
                        {tableHead}
                        {tableBodyBlock}
                    </OKTable>
                </article>
            );
        }

        return (
            <OKSectionBox>
                <header className="transfers-agenda clearfix">
                    <div className="pull-left">
                        <OKBoxTitle value={headerTitle} />
                    </div>
                    <div className="pull-right">
                        {addBeneficiaryButton}
                    </div>
                </header>
                {content}
            </OKSectionBox>
        );
    }

}

TransfersAgenda.propTypes = {
    immBeneficiaries: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
};

module.exports = TransfersAgenda;
